var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-span-1 border rounded-xl bg-indigo-200 shadow-xl px-9 py-11 flex flex-col hover:border-2 hover:shadow-2xl",
    class: `border-${_vm.colorTheme(_vm.name)}-600 bg-${_vm.colorTheme(_vm.name)}-100`
  }, [_c('SubscriptionCardHeader', {
    attrs: {
      "name": _vm.name,
      "description": _vm.description
    }
  }), _vm._v(" "), false ? _c('SubscriptionPrice', {
    attrs: {
      "price": _vm.price
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-7.5"
  }), _vm._v(" "), _c('SubscriptionDetails', {
    staticClass: "mb-9",
    attrs: {
      "details": _vm.details
    }
  }), _vm._v(" "), _c('SelectSubscription', {
    attrs: {
      "name": _vm.name,
      "is-current": _vm.isCurrent
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }